import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '~/components/Button';

export default class ConfirmDeleteDialog extends React.Component {
  warningContent = (hasRecentResponse) => {
    if (hasRecentResponse != true) return;

    return (
      <p>
        This form was responded to within the last 7 days. Are you sure you want
        to delete this form?
      </p>
    );
  };

  render() {
    const { open, onClose, formID, hasRecentResponse } = this.props;

    return (
      <Dialog open={open} onExited={onClose.bind(this, false)}>
        <DialogTitle disableTypography>
          Are you sure you want to delete this form?
        </DialogTitle>

        <DialogContent>{this.warningContent(hasRecentResponse)}</DialogContent>

        <DialogActions>
          <Button
            variant="secondary"
            onClick={this.props.onClose.bind(this, false, null)}>
            Cancel
          </Button>

          <Button
            onClick={this.props.onClose.bind(this, true, formID)}
            variant="primary">
            Delete form
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmDeleteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  hasRecentResponse: PropTypes.bool,
  formID: PropTypes.string,
};
